import { Component } from '@angular/core';

@Component({
  selector: 'irembogov-root',
  templateUrl: './app.component.html',
})
export class AppComponent {}
